import ApiClient from '../ApiClient';

const WhatsAppServices = {

    // get the whatsapp connection status for a given business id `getWhatsAppConnectionStatus`
    /*
    returns object with the following properties:
    {
      "configurationExists": true,
      "connected": false,
      "status": "NO_TOKEN",
      ..
        ...if configurationExists is true and and connected is `false`, 
            app should call `connectWhatsAppForOAuth url` to connect whatsapp for oauth
        ...if configurationExists is true and and Status is `CONNECTED`, connected is `true`, 
            hide web hooksection and show test section or dashboard section.
        ...if configurationExists is false, and  ConnectUrl is null,
            app should call `saveWhatsAppConfiguration api` to save the config and then 
            call the `connectWhatsAppForOAuth url` to connect whatsapp for oauth.
            Once conected, app should call `getWhatsAppConnectionStatus` to get the connection status.
        ...if configurationExists is true and connected is `false`
            call `generateWebhook` to generate webhook.
    }
    */
    async getWhatsAppConnectionStatus() {
        const resp = await ApiClient.get(`/Whatsapp/status`);
        return resp;
    },

    async saveWhatsAppConfiguration(configuration) {
        const resp = await ApiClient.post('/Whatsapp/configuration/save', configuration);
        return resp;
    },

    async getWebhookConfiguration() {
        const resp = await ApiClient.get(`/Whatsapp/webhook-url-details`);
        return resp;
    },

     async getAllLeads(queryParams) {
        const resp = await ApiClient.get(`/Whatsapp/leads-with-last-message`, { params: queryParams });
        return resp;
    },

     async getLeadById(leadId, params) {
        const resp = await ApiClient.get(`/Whatsapp/messages/${leadId}`, { params });
        return resp;
    },

     async sendMessage(payload) {
        const resp = await ApiClient.post('/Whatsapp/send', payload);
        return resp;
    },

    async login(wabaId) {
        const resp = await ApiClient.post(`/Whatsapp/login`, { wabaId });
        return resp;
    },

    async logout(wabaId) {
        const resp = await ApiClient.get(`/Whatsapp/logout`, { wabaId });
        return resp;
    },

    async eraseData() {
        const resp = await ApiClient.delete(`/Whatsapp/erase-all-data`);
        return resp;
    },

}

export default WhatsAppServices;